// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    someData: null ,// 初始化状态
		selectedData: null // 用于存储从B页面选择的数据
  },
  mutations: {
    setSomeData(state, payload) {
      state.someData = payload;
    },
		setSelectedData(state, data) {
			state.selectedData = data
		}
  },
  actions: {
    // 如果需要异步操作，可以在这里定义
		updateSelectedData({ commit }, data) { 
			commit('setSelectedData', data)
		}
  },
  getters: {
    // 如果需要派生状态，可以在这里定义
		getSelectedData: state => state.selectedData
  }
});